export const ScaleDefaultInfo = {
  defaultScaleDelta: 1.5,
  minScale: 0.1,
  maxScale: 10.0,
  defaultScale: "page-width",
}